export const generateId = () => Math.random().toString(36).slice(2, 9);
export const now = () => new Date().toISOString();
export const toSlug = (name) => name.toLowerCase().replace(/[^a-z0-9\s-]/g,"").trim().replace(/\s+/g,"-");
